import {v4 as uuidv4} from "uuid";

export type TimeSlot = {
    TimeSlotId?: string,
    Title: string,
    StartsAt: string,
    EndsAt: string,
    EventId: string,
}

export function newTimeSlot(): TimeSlot {
    return {
        TimeSlotId: uuidv4(),
        Title: "",
        StartsAt: "",
        EndsAt: "",
        EventId: "",
    };
}

export function newTimeSlotArray(): TimeSlot[] {
    return [];
}